import LocationHelper from './location_helper';

export function compact(array) {
  return array.filter(Boolean);
}

export function flatten(array) {
  return array.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []);
}

export function last(array) {
  return array.slice(-1)[0];
}

export function identity(i) {
  return i;
}

export function isNumber(obj) {
  return typeof obj === 'number' && !isNaN(obj);
}

export function isString(obj) {
  return typeof obj === 'string';
}

export function isClient() {
  return typeof document !== 'undefined';
}

export function noop() {}

export function pluralize(number, plural, singular) {
  if (number === 1) return singular;
  return plural;
}

export function range(...args) {
  const [start, stop, step = 1] = args.length === 1 ? [0, args[0]] : args;
  return Array.from(Array(Math.ceil((stop - start) / step)), (k, i) => start + i * step);
}

export function animationsDisabled() {
  return false;
  // return typeof ANIMATIONS_DISABLED !== 'undefined' && !!ANIMATIONS_DISABLED;
}

export function isSelenium() {
  try {
    return (
      navigator.webdriver ||
      window.document.documentElement.getAttribute('webdriver') ||
      '_Selenium_IDE_Recorder' in window ||
      '__webdriver_script_fn' in document
    );
  } catch (e) {
    return false;
  }
}

export async function isProxyHarBackend() {
  if (isSelenium()) {
    try {
      let response = await fetch(
        `${LocationHelper.getUrlForSubdomain('api')}/rest/v3/200x/${Math.random().toString(36).substring(2, 15)}`,
        {
          method: 'GET',
          mode: 'cors',
        }
      );
      console.log('isProxyHarBackend', response);
      if (response.status === 404 || response.status === 0) {
        return true;
      }
    } catch (e) {
      return false;
    }
  }
  return false;
}
